<div class="go-to-route-icon" [class.go-to-route-icon_fixed]="fixedPosition" [class.disabled]="disabled">
  <ng-container *ngIf="showText; else defaultView">
    <a [routerLink]="href"
       [queryParams]="params"
       [queryParamsHandling]="queryParamsHandling"
       [target]="newTab ? '_blank' : '_self'"
       class="pointer">
      <i class="{{icon}} {{iconClass}}"></i>
      <span class="margin-small-left go-to-route-icon_text">{{tooltip | translate}}</span>
    </a>
  </ng-container>
  <ng-template #defaultView>
    <a [routerLink]="href"
       [queryParams]="params"
       [queryParamsHandling]="queryParamsHandling"
       [target]="newTab ? '_blank' : '_self'">
      <span pTooltip="{{tooltip | translate}}"
            tooltipPosition="{{tooltipPosition}}"
            [attr.aria-label]="tooltip"
            class="go-to-route-icon_tooltip">
        <i class="{{icon}} {{iconClass}} pointer"></i>
      </span>
    </a>
  </ng-template>
</div>
